export function dashboardQueryScope({
  authTenantId = '',
  supportTenantId = '',
  supportAccessLevel = '',
  dealerActive = false,
  dealerId = '',
  dealerTenantId = '',
} = {}) {
  if (!dealerActive && supportTenantId) {
    return {
      tenantId: supportTenantId,
      scope: `support:${supportTenantId}:${supportAccessLevel || 'view'}`,
    };
  }
  if (dealerActive && dealerTenantId) {
    return {
      tenantId: dealerTenantId,
      scope: `dealer:${dealerId || ''}:${dealerTenantId}`,
    };
  }
  return {
    tenantId: authTenantId || '',
    scope: `member:${authTenantId || ''}`,
  };
}
